import React, { useState, useEffect } from "react";
import { Col, Row, Input, Label, Form, FormGroup } from "reactstrap";
import { TextField } from "@material-ui/core";

// Redux
import { connect } from "react-redux";

//Firebase Storage
import {
  getFileList,
  singleFileUploader,
  FirebaseStorageUploader,
} from "../../../utils/FirebaseStorage/FirebaseStorage";

//Componentes
import Loading from "../../../components/modales/loadingModal";
import LoadingModalTransparent from "../../../components/modales/loadingModalTransparent";
import CustomModalRetiro from "../../../components/modales/customModalRetiro";

import CardAdjunto from "../componentes/CardAdjunto";
//API
import { functionsHttpsCallable } from "../../../utils/FirebaseStorage/firebase";

const getRetiro = functionsHttpsCallable("ape_getRetiroPorId");
const exportarRetiro = functionsHttpsCallable("ape_exportarRetiro");
const editarRetiro = functionsHttpsCallable("ape_editarRetiro");

//Utils
const { areas, areasSegFase } = require("../utils/data");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

const ModalInformacionRetiro = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [attachment, setAttachment] = useState([]);
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [data, setData] = useState({});
  const [firma, setFirma] = useState(false);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(parseInt(userData.userId));
  const [signatureFile, setSignatureFile] = useState();

  useEffect(() => {
    getDataRetiro();
    getInfoFirma();
    getInfoAdjutnos();
  }, []);

  useEffect(() => {
    getDataRetiro();
    getInfoFirma();
    getInfoAdjutnos();
  }, [props.id]);

  const getDataRetiro = async () => {
    setLoading(true);
    const body = {
      retiroId: props.id,
    };
    const tempData1 = await getRetiro(body);
    setData({ ...tempData1.data.data });
    setLoading(false);
  };

  const getInfoFirma = async () => {
    const fileList = await getFileList(`signatures/${userId}`);
    setFirma(fileList.length > 0);
  };

  const getInfoAdjutnos = async () => {
    const fileList = await getFileList(`retiros/${props.id}`);
    setAttachmentsList(fileList);
  };

  const downloadRetiro = async (id) => {
    setModalTransaction(true);
    let body = {
      retiroId: props.id,
    };
    try {
      let downloadLink = await exportarRetiro(body);
      let downloadWindow = window.open(
        downloadLink.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      setModalTransaction(false);
      props.success("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      props.error("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const getNewState = (state) => {
    switch (state) {
      case "VERIFICACION1":
        const res = areas.reduce((acum, current) => acum && data[current.ok]);
        if (res) return "VERIFICACION_JEFE";
        else return "VERIFICACION1";
      case "VERIFICACION_JEFE":
        return "VERIFICACION_ADMINISTRATIVO";
      case "VERIFICACION_ADMINISTRATIVO":
        return "VERIFICACION_CONTRATACION";
      case "VERIFICACION_CONTRATACION":
        return "VERIFICACION_NOMINA";
      case "VERIFICACION_NOMINA":
        return "FINALIZADO";
      default:
        return "VERIFICACION1";
    }
  };
  const handleAddFiles = (newFile) => {
    setAttachment([...attachment, newFile]);
  };

  const handleUpdateState = (key, value) => {
    let tempData = { ...data };
    tempData[key] = value;
    setData(tempData);
  };

  const handleUpdateNumberState = (key, value) => {
    if (value) {
      let tempData = { ...data };
      tempData[key] = parseInt(value);
      setData(tempData);
    }
  };

  const handleUpdate = async () => {
    await updateRetiro();
    props.toggle();
  };

  const uploadSignature = async () => {
    await singleFileUploader(
      signatureFile,
      `signatures/${userId}`,
      `${userId}`
    );
  };

  const uploadFiles = async () => {
    for (let file of attachment) {
      await singleFileUploader(file.file, `retiros/${props.id}`, `${file.id}`);
    }
    // await FirebaseStorageUploader(attachment, `/retiros/${props.id}`)
  };

  const updateRetiro = async () => {
    setModalTransaction(true);
    const body = { data: data, retiroId: props.id };
    await editarRetiro(body);
    setModalTransaction(false);
  };

  return (
    <React.Fragment>
      <LoadingModalTransparent isOpen={modalTransaction} />
      <CustomModalRetiro
        modal={props.modal}
        toggle={() => props.toggle()}
        title={`Informacion Retiro ${props.text ?? "NA"}`}
        buttonTitle={"Guardar"}
        firma={firma}
        id={props.id}
        enableOk={true}
        setUpdFile={() => {
          setSignatureFile();
        }}
        onClick={() => {
          handleUpdate();
        }}
        onDownload={() => {
          downloadRetiro();
        }}
        // buttonLoading={cancelando}
      >
        {loading ? (
          <Loading />
        ) : (
          <div>
            {areas.map((area, index) => {
              const disable = !(
                data[area.responsable] === userId &&
                data.estadoRetiro === area.estado_editable
              );
              return (
                <Row className="retiro-area">
                  <Col lg="5" md="5" xs="12">
                    <TextField
                      required
                      disabled={disable}
                      autoComplete="off"
                      key={`key_concepto_${area.id}`}
                      id={`input_concepto_${area.id}`}
                      fullWidth
                      label={`Concepto ${area.name}`}
                      defaultValue={data[area.concepto] ?? ""}
                      value={data[area.concepto] ?? ""}
                      onChange={(e) => {
                        handleUpdateState(area.concepto, e.target.value);
                      }}
                      margin="normal"
                    />
                  </Col>
                  <Col lg="4" md="4" xs="12">
                    <TextField
                      required
                      disabled={disable}
                      autoComplete="off"
                      key={`key_valor_${area.id}`}
                      id={`input_valor_${area.id}`}
                      fullWidth
                      label={"Valor"}
                      defaultValue={data[area.costo] ?? ""}
                      value={data[area.costo] ?? ""}
                      onChange={(e) => {
                        handleUpdateNumberState(area.costo, e.target.value);
                      }}
                      margin="normal"
                    />
                  </Col>
                  <Col className="retiro-checkbox" lg="3" md="3" xs="12">
                    <p></p>
                    <Form>
                      <FormGroup check inline>
                        <Input
                          key={`checkbox_${index}`}
                          type="checkbox"
                          onChange={(e) => {
                            handleUpdateState(area.ok, e.target.checked);
                          }}
                          disabled={disable}
                          checked={data[area.ok]}
                        />
                        <Label check>Visto Bueno</Label>
                      </FormGroup>
                    </Form>
                  </Col>
                </Row>
              );
            })}
            <div>
              <CardAdjunto
                attachmentsList={attachmentsList}
                list={areasSegFase}
                estado={data.estadoRetiro}
                addFile={(e) => handleAddFiles(e)}
              />
            </div>
          </div>
        )}
      </CustomModalRetiro>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ModalInformacionRetiro);
